'use strict';

exports.__esModule = true;
exports.default = {
  SOCIAL: 'social',
  REVERSE_TIME: 'reverse_time',
  TIME: 'time'
};
//# sourceMappingURL=CommentsOrderBy.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/CommentsOrderBy.js
// module id = 449
// module chunks = 198517197184460